import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Questions = lazy(() => import('./Questions'))

const QuestionsRoutes = [
    {
        path: '/organization_questions_setup',
        component: Questions,
        auth: authRoleAccess.case_questions_setup,
    },
   
]

export default QuestionsRoutes